import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ModalComponent } from "@modal/modal.component";
import { TermsService } from "@terms-service/terms.service";
import { ThesaurusService } from "@thesaurus-service/thesaurus.service";
import { UtilitiesService } from "@utilities-service/utilities.service";

@Component({
    selector: 'app-thesaurus-footer',
    templateUrl: './thesaurus-footer.component.html',
    styleUrl: './thesaurus-footer.component.scss',
    standalone: false
})
export class ThesaurusFooterComponent {

    @Input() isExplode: boolean = false;
    @Input() isMajor: boolean = false;
    @Input() displayPagination: boolean = false;
    @Output() submitThesaurusEntriesEvent = new EventEmitter<{ event: Event, joinType: string }>();
    @Output() getPreviousPageEvent = new EventEmitter<void>();
    @Output() getNextPageEvent = new EventEmitter<void>();
    @Input() thesaurusId: string = "";
    subscription: any;
    pageCountLabel: string = '50';
    @ViewChild('modal') modal!: ModalComponent;

    joinTypes: { label: string, default: boolean, value: string }[] = [
        { label: 'OR', default: true, value: ' OR ' },
        { label: 'AND', default: false, value: ' AND ' },
        { label: 'NOT', default: false, value: ' NOT ' }
    ];
    joinType: string = this.joinTypes[0]['value'];

    disabledClass: string = 'disabled';
    prevPageBtnID: string = "previousPageButton";
    nextPageBtnID: string = "nextPageButton";
    
    
    constructor(
        private thesaurusService: ThesaurusService,
        public termsService: TermsService,
        private utilitiesService: UtilitiesService
    ) {
        // Initialization logic can go here
    }

    ngOnInit(): void {
        // Component initialization logic can go here
        this.subscription = this.termsService.thesaurusEntries$.subscribe(entries => {
            // Handle the retrieved entries
            if (entries.length > 0) {
                // Turn on pagination
                this.toggleDisabledClassForNextPage();
                this.scrollToTopOfTermsList();
                this.showButtons();
                if (this.termsService.getOffset() > 0) {
                    this.enablePrevPageBtn();
                } else {
                    this.disablePrevPageBtn();
                }
            }
        });
    }

    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    enablePrevPageBtn() {
        let prevPageElement = document.getElementById(this.prevPageBtnID);
        prevPageElement?.classList.remove(this.disabledClass);
    }

    disablePrevPageBtn() {
        let prevPageElement = document.getElementById(this.prevPageBtnID);
        prevPageElement?.classList.add(this.disabledClass);
    }

    submitThesaurusEntries(event: Event): void {
        event.preventDefault();
        this.submitThesaurusEntriesEvent.emit({ event: event, joinType: this.joinType });
    }

    getPreviousPage(event: Event): void {
        event.preventDefault();
        this.getPreviousPageEvent.emit();
    }

    getNextPage(event: Event): void {
        event.preventDefault();
        this.getNextPageEvent.emit();
    }

    //When true, it will hide the Frills view of the Lexicon, and display the No Frills view.
    hideFrillsLexicon() {
      return this.utilitiesService.getLookupQueryParam();
    }

      //If a "next page" exists, toggle the .disabled class for the "Next" button
      toggleDisabledClassForNextPage() {
        let nextPageElement = document.getElementById(this.nextPageBtnID);
        if (this.thesaurusService.isNextPageExists()) {
          nextPageElement?.classList.remove(this.disabledClass);
        } else {
          nextPageElement?.classList.add(this.disabledClass);
        }
      }
    
      //When new terms are loaded, scroll up to the first entry in the list
      scrollToTopOfTermsList() {
        let terms = document.getElementsByClassName('main-term-wrapper');
        if (terms.length > 0) {
          terms[0].scrollIntoView(true);
        }
      }
    
        //Remove the .hidden class to show the pagination buttons. These are hidden by default.
      showButtons() {
        if (this.thesaurusService.isDisplayPrevNextButtons()) {
          let el = document.querySelector('.pagination-wrapper');
          el?.classList.remove('hidden');
        } else {
          let el = document.querySelector('.pagination-wrapper');
          el?.classList.add('hidden');
        }
      }
      
    noResults(): boolean {
    return this.termsService.getIsSearchResults() && (this.termsService.getEntries()?.length ?? 0) == 0;
  }

}